module.exports = __webpack_public_path__ + "static/img/W.8ea8fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/W.png
// module id = 5QBT
// module chunks = 0